export default __webpack_public_path__ + "static/media/LEO.8dfc565b.png";